import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardMedia from "@mui/material/CardMedia";
import Rating from "@mui/material/Rating";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiBadge from "components/SuiBadge";

import { capitalCase } from "capital-case";
import NumberFormat from "react-number-format";
import { Carousel } from "antd";
import moment from "moment";
import Checkbox from "@mui/material/Checkbox";

import curved9 from "assets/images/upstyled/default_background.png";
import colors from "assets/theme/base/colors";

import CategoryContext from "context/category-context";
import {
  canResizeImageUrl,
  getStyleImages,
  getFileImage,
  getOnLineTechPackImages,
} from "utils/imageHelper";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

function StyleCard3({
  product,
  size = "md",
  sx = {},
  detailUrl = null,
  handleSelectStyle,
  isSelected,
  imageMode = "normal",
  metaFilesKey = ["imageFiles", "techPacksFiles", "referenceFiles"],
}) {
  const styleMeta = product?.style ? product.style : {};

  let styleImages = getStyleImages(product, false, metaFilesKey);
  styleImages = styleImages.filter((f) => f?.type && f.type.includes("image")); //remove pdf format

  const styleNumber = styleMeta?.style_number ? styleMeta.style_number : "N/A";

  return (
    <SuiBox
      sx={{
        my: 2,
        mx: 1,
        width: 192,
        height: 290,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        backgroundColor: "transparent",
        overflow: "visible",
        borderColor: ({ borders }) => borders.borderColor,
        boxShadow: ({ boxShadows: { md } }) => md,
        border: ({ borders }) =>
          isSelected ? "2px solid rgb(34 211 238)" : `2px solid ${borders.borderColor}`,
        ...sx,
      }}
      onClick={handleSelectStyle ? () => handleSelectStyle(!isSelected) : null}
    >
      <Carousel
        arrows={true}
        dots={false}
        prevArrow={
          <div>
            <button
              class="react-multiple-carousel__arrow-small react-multiple-carousel__arrow--left-small "
              type="button"
            ></button>
          </div>
        }
        nextArrow={
          <div>
            <button
              class="react-multiple-carousel__arrow-small react-multiple-carousel__arrow--right-small "
              type="button"
            ></button>
          </div>
        }
      >
        {styleImages.length > 0 ? (
          styleImages.map((img) => (
            <SuiBox
              position="relative"
              sx={{
                cursor: "pointer",
                overflow: "hidden",
                margin: "0 auto",
              }}
            >
              <ImageCardWrapper data={img} height={240} width={192} />
            </SuiBox>
          ))
        ) : (
          <SuiBox
            position="relative"
            sx={{
              cursor: "pointer",
              overflow: "hidden",
              margin: "0 auto",
            }}
          >
            <SuiBox
              sx={{
                overflow: "hidden",
                backgroundImage: ({
                  functions: { rgba, linearGradient },
                  palette: { gradients },
                }) =>
                  `${linearGradient(
                    rgba(gradients.secondary.main, 0.2),
                    rgba(gradients.secondary.state, 0.4)
                  )}`,
                height: 240,
                width: 190,
                margin: 0,
                boxShadow: ({ boxShadows: { md } }) => md,
                objectFit: "contain",
                objectPosition: "center",
              }}
            />{" "}
          </SuiBox>
        )}
      </Carousel>
      <SuiBox sx={{ position: "absolute", right: 10, top: 10 }}>
        <Tooltip title={styleNumber}>
          <SuiBadge
            variant="contained"
            color="secondary"
            badgeContent={
              <SuiTypography
                variant="text"
                textTransform="none"
                color="secondary"
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "1",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {styleNumber}
              </SuiTypography>
            }
          />
        </Tooltip>
      </SuiBox>
      <SuiBox py={1} px={1}>
        <div>
          <SuiBox display="flex" justifyContent="space-between" alignItems="top">
            <Tooltip title={product.title}>
              <SuiBox onClick={() => handleSelectStyle(!isSelected)} sx={{ cursor: "pointer" }}>
                <SuiTypography
                  variant="body1"
                  fontWeight="regular"
                  color="text"
                  lineHeight="1"
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {product.title}
                  {product?.collection?.title ? `(${product?.collection?.title})` : null}
                </SuiTypography>
              </SuiBox>
            </Tooltip>
          </SuiBox>
        </div>
      </SuiBox>
    </SuiBox>
  );
}

export default StyleCard3;
